import { NavLink } from 'react-router-dom';
import { Cpu, Mail, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <Cpu className="h-7 w-7 text-accent" />
              <span className="font-heading text-xl font-bold">Upnov IA</span>
            </div>
            <p className="text-gray-300 mb-6">
              Formation professionnelle en Intelligence Artificielle pour entreprises.
              Développez les compétences de vos équipes avec nos programmes sur mesure.
            </p>
            <div className="flex space-x-4">
              {/* <a href="https://facebook.com" className="text-gray-300 hover:text-white transition-colors" aria-label="Facebook">
                <Facebook size={20} />
              </a> */}
              <a href="https://twitter.com" className="text-gray-300 hover:text-white transition-colors" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="https://www.linkedin.com/company/upnov" className="text-gray-300 hover:text-white transition-colors" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
              {/* <a href="https://instagram.com" className="text-gray-300 hover:text-white transition-colors" aria-label="Instagram">
                <Instagram size={20} />
              </a> */}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Liens rapides</h3>
            <ul className="space-y-4">
              <li>
                <NavLink to="/" className="text-gray-300 hover:text-white transition-colors">
                  Accueil
                </NavLink>
              </li>
              <li>
                <NavLink to="/formation-ia-entreprise/" className="text-gray-300 hover:text-white transition-colors">
                  Nos formations
                </NavLink>
              </li>
              <li>
                <NavLink to="/about/" className="text-gray-300 hover:text-white transition-colors">
                  À propos
                </NavLink>
              </li>
              <li>
                <NavLink to="/blog/" className="text-gray-300 hover:text-white transition-colors">
                  Blog
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact/" className="text-gray-300 hover:text-white transition-colors">
                  Contact
                </NavLink>
              </li>
              <li>
                <NavLink to="/demarrer-votre-diagnostic-ia-entreprise/" className="text-indigo-300 hover:text-white transition-colors font-medium">
                  ✦ Diagnostic IA gratuit
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Formations */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Nos formations</h3>
            <ul className="space-y-4">
              <li>
                <NavLink to="/formation-ia-entreprise/" className="text-gray-300 hover:text-white transition-colors">
                  Introduction à l'IA
                </NavLink>
              </li>
              <li>
                <NavLink to="/formation-ia-entreprise/" className="text-gray-300 hover:text-white transition-colors">
                  IA pour managers
                </NavLink>
              </li>
              <li>
                <NavLink to="/accompagnement-ia-entreprise/" className="text-gray-300 hover:text-white transition-colors">
                  Implémenter l'IA dans votre entreprise
                </NavLink>
              </li>
              <li>
                <NavLink to="https://www.upnov.com/blog/ia-et-conformite/" className="text-gray-300 hover:text-white transition-colors">
                  IA et éthique
                </NavLink>
              </li>
              <li>
                <NavLink to="/formation-ia-entreprise/" className="text-gray-300 hover:text-white transition-colors">
                  Formations sur mesure
                </NavLink>
              </li>
              <li>
                <NavLink to="/formation-ia-paris/" className="text-gray-300 hover:text-white transition-colors">
                  Formation IA Paris & IDF
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-accent shrink-0 mt-0.5" />
                <span className="text-gray-300"> Coeur Défense, 92400 Courbevoie, France</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-accent shrink-0" />
                <a  className="text-gray-300 hover:text-white transition-colors">
                  info at upnov.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <hr className="border-gray-700 my-10" />

        <div className="flex flex-col md:flex-row md:justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            &copy; {currentYear} Upnov IA Tous droits réservés.
          </p>
          <div className="flex space-x-6 text-sm text-gray-400">
            <NavLink to="/mentions-legales/" className="hover:text-white transition-colors">Mentions légales</NavLink>
            <NavLink to="/politique-de-confidentialite/" className="hover:text-white transition-colors">Politique de confidentialité</NavLink>
            <button
              onClick={() => (window as any).tarteaucitron?.userInterface.openPanel()}
              className="hover:text-white transition-colors cursor-pointer"
            >
              Gestion des cookies
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;